export default __webpack_public_path__ + "images/very_unhappy.2a9ecab86ba1f1be0faaa55841d0ee6e.svg";